module.exports = __webpack_public_path__ + "assets/images/tutorial1.a8be5d4.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/tutorial/tutorial1.png
// module id = 452
// module chunks = 1